import { RootState } from "../rootReducer";
import { isAdmin } from "config/constants";

export const marketAreasInfo = (state: RootState) =>
  state.MarketAreasReducer.marketAreasInfo;

export const isLoading = (state: RootState) =>
  state.MarketAreasReducer.isLoading;

export const searchedMarketAreaName = (state: RootState) =>
  state.MarketAreasReducer.searchedName;

export const marketAreaSettings = (state: RootState) =>
  state.MarketAreasReducer.settings;

export const isMarketAreaSettingsLoading = (state: RootState) =>
  state.MarketAreasReducer.isSettingsLoading;

export const isMarketAreasAvailable = (state: RootState) =>
  state.MarketAreasReducer.isAvailable;

export const canAccessMarketAreas = (state: RootState) =>
  isAdmin(state.SignInReducer.userInfo.roles) ||
  state.MarketAreasReducer.isAvailable === true;

export const isMarketAreaAccessPending = (state: RootState) =>
  !isAdmin(state.SignInReducer.userInfo.roles) &&
  state.MarketAreasReducer.isAvailable === null;
